import CtaButtonGroup, { CtaType } from "@/components/molecules/CtaButtonGroup";
import Image from "next/image";
import React from "react";

interface BonusItemProps {
  icon: string;
  title: string;
  originalPrice: string;
  discountedPrice: string;
}

type AdditionalBonusProps = {
  title: string;
  description: string;
  ctas: CtaType[];
  bonusItems: BonusItemProps[];
  subTitle: string;
};

const BonusItem: React.FC<BonusItemProps> = ({
  icon,
  title,
  originalPrice,
  discountedPrice,
}) => (
  <div className={`flex items-center rounded-xl border border-purple-1 p-4`}>
    {/* <div className="mr-4 text-3xl">{icon}</div> */}
    
      <div className="mr-4 text-3xl">
         <Image src={icon} alt={title} width={100} height={100} />
      </div>
    
    <div>
      <h3 className="font-semibold">{title}</h3>
      <p>
        <span className="mr-2 line-through">{originalPrice}</span>
        <span className="font-bold text-purple-3">{discountedPrice}</span>
      </p>
    </div>
  </div>
);

const AdditionalBonus: React.FC<AdditionalBonusProps> = ({
  title,
  description,
  ctas,
  bonusItems,
  subTitle,
}) => {

  return (
    <div className="mx-auto max-w-4xl px-4 py-16">
      <h2 className="mb-6 text-center text-title1 font-semibold">{title}</h2>
      <p className="mb-8 text-center text-body-16 text-grey-4">{description}</p>

      <div className="mb-8 grid grid-cols-1 gap-6 md:grid-cols-2">
        {bonusItems &&
          bonusItems.map((item, index) => (
            <BonusItem
              key={index}
              icon={item.icon}
              title={item.title}
              originalPrice={item.originalPrice}
              discountedPrice={item.discountedPrice}
            />
          ))}
      </div>

      <div className="mt-12 text-center flex flex-col items-center justify-center">
        <p className="mb-4">{subTitle}</p>
        <CtaButtonGroup align="sm:center" ctas={ctas} affiliateButton={true} />
        <div className="flex items-center justify-center gap-2 sm:justify-start mt-4">
          <img
            src="/images/icons/percentage-pink.svg"
            alt="company logo"
            className="h-4 w-4"
          />
          <p className="text-center text-body-12 font-normal text-grey-4 ">
            Money back guarantee
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdditionalBonus;
